function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 49.486,
    height: 49.486,
    viewBox: "0 0 49.486 49.486",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group_8",
    "data-name": "Group 8",
    transform: "translate(-3112.874 -149.929)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_notifications",
    transform: "translate(3112.874 153.736)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Bounds",
    d: "M45.679,0V45.679H0V0Z",
    fill: "none",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M16,39a3.838,3.838,0,0,1-3.764-3.9h7.53A3.839,3.839,0,0,1,16,39Zm16-5.849H0V31.2l3.764-3.9V16.574A12.541,12.541,0,0,1,13.177,4.251V2.926a2.825,2.825,0,1,1,5.646,0V4.251a12.543,12.543,0,0,1,9.412,12.324V27.3L32,31.2v1.95Z",
    transform: "translate(6.126 3.264)",
    fill: "#9da1b2",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Notification",
    d: "M0,7.613a7.613,7.613,0,1,1,7.613,7.613A7.613,7.613,0,0,1,0,7.613Z",
    transform: "translate(3147.134 149.929)",
    fill: "#f75151",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/Notification.fb5d80647f78d030c207e04a89960d8a.svg";
export { ForwardRef as ReactComponent };